const initState = null;

const userNavigationAccess = (state = initState, action) => {
    // console.log(action
    switch (action.type) {
        case 'SET_USER_NAVIGATION_ACCESS':
            state = action.nagivationAccess;                  
            return state;
        default: return state;
    }
};

export default userNavigationAccess;